module.exports = __webpack_public_path__ + "media/images/common/img_notice-76e6dde6e28d1dea17ed9362e7bcb0c5.png";